import { useMemo } from 'react';

import Link from 'next/link';
import { useRouter } from 'next/router';
import { UnorderedList } from 'shared/components/UnorderedList';
import { getCrawlerCategoryFiltersLinkHref } from 'search/utils/getCrawlerCategoryFiltersLinkHref';
import { getCrawlerChildrenCategories } from 'search/utils/getCrawlerChildrenCategories';
import { transformCategoryFacet } from 'search/utils/categoryFilterUtils';
import { getConstructorCategoriesStrings } from 'search/enums/translations';

export const SearchFilterCategoryMobileCrawler = ({ facet, topLevelCategory }) => {
  const { pathname, query } = useRouter();

  const transformedCategories = useMemo(
    () => transformCategoryFacet(facet?.options, topLevelCategory),
    [JSON.stringify(facet?.options)],
  );

  const categoriesList =
    getCrawlerChildrenCategories({
      query,
      pathname,
      categories: transformedCategories?.children,
    }) || [];

  return (
    <UnorderedList data-qa="search_filter_list">
      {categoriesList.map((category) => {
        return (
          <li key={category.value}>
            <Link
              href={getCrawlerCategoryFiltersLinkHref({ pathname, query, category, facet })}
              key={category.display_name}
              passHref
              prefetch={false}
              scroll
              shallow
              legacyBehavior
            >
              {getConstructorCategoriesStrings(category.display_name)}
            </Link>
          </li>
        );
      })}
    </UnorderedList>
  );
};
